import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
    Breadcrumb,
    BreadcrumbList,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from '@kuda/ui';

const Breadcrumbs = ({ isChange, onIsModified }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const pathnames = location.pathname.split('/').filter((x) => x);

    // Get search parameters
    const searchParams = new URLSearchParams(location.search);
    const selectedCluster = searchParams.get('selectedCluster');

    const handleClusterClick = () => {
        if (!isChange) {
            navigate(`/secrets?selectedCluster=${selectedCluster}`);
        } else {
            onIsModified();
        }
    };

    const handleHomeClick = (e) => {
        e.preventDefault();
        if (!isChange) {
            navigate('/secrets');
        } else {
            onIsModified();
        }
    };

    return (
        <Breadcrumb>
            <BreadcrumbList>
                <BreadcrumbItem>
                    <BreadcrumbLink asChild>
                        <Link to="/secrets" onClick={handleHomeClick}>Home</Link>
                    </BreadcrumbLink>
                </BreadcrumbItem>

                {pathnames.map((value, index) => {
                    const to = `/${pathnames.slice(0, index + 1).join('/')}`;
                    const isLast = index === pathnames.length - 1;

                    // Replace "view-secret" with the selected cluster name
                    if ((value === 'view-secret' || value === 'update-secret') && selectedCluster) {
                        return (
                            <React.Fragment key={to}>
                                <BreadcrumbSeparator />
                                <BreadcrumbItem>
                                    <BreadcrumbLink asChild>
                                        <button type="button" onClick={handleClusterClick} style={{ cursor: 'pointer' }}>
                                            {selectedCluster}
                                        </button>
                                    </BreadcrumbLink>
                                </BreadcrumbItem>
                            </React.Fragment>
                        );
                    }

                    return (
                        <React.Fragment key={to}>
                            <BreadcrumbSeparator />
                            <BreadcrumbItem>
                                {isLast ? (
                                    <BreadcrumbPage>{value}</BreadcrumbPage>
                                ) : (
                                    <BreadcrumbLink asChild>
                                        <Link to={to}>{value}</Link>
                                    </BreadcrumbLink>
                                )}
                            </BreadcrumbItem>
                        </React.Fragment>
                    );
                })}
            </BreadcrumbList>
        </Breadcrumb>
    );
};

export default Breadcrumbs;
